var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("tr", { staticClass: "opportunity-list-item" }, [
    _c("td", [_vm._v(_vm._s(_vm.opportunity.id))]),
    _vm._v(" "),
    _c("td", [_vm._v(_vm._s(_vm._f("nullable")(_vm.opportunity.name)))]),
    _vm._v(" "),
    _c("td", [
      _vm._v(
        _vm._s(
          _vm._f("nullable")(
            _vm._f("sentenceCase")(_vm.opportunity.appearance_type)
          )
        )
      ),
    ]),
    _vm._v(" "),
    _c("td", [
      _vm._v(
        _vm._s(
          _vm._f("nullable")(_vm._f("sentenceCase")(_vm.opportunity.field_set))
        )
      ),
    ]),
    _vm._v(" "),
    _c("td", [
      _vm._v(
        _vm._s(
          _vm._f("nullable")(
            _vm._f("sentenceCase")(
              _vm._f("parseArray")(_vm.opportunity.optional_fields)
            )
          )
        )
      ),
    ]),
    _vm._v(" "),
    _c(
      "td",
      [
        _vm.valueType === "points"
          ? [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("nullable")(_vm.opportunity.points + "pts")) +
                  "\n    "
              ),
            ]
          : _vm.valueType === "budget"
          ? [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm._f("nullable")(_vm.moneySymbol + _vm.opportunity.budget)
                  ) +
                  "\n    "
              ),
            ]
          : [_vm._v("\n      " + _vm._s(_vm._f("nullable")(null)) + "\n    ")],
      ],
      2
    ),
    _vm._v(" "),
    _c("td", [
      _vm._v(
        _vm._s(
          _vm._f("nullable")(
            _vm.opportunity.category ? _vm.opportunity.category.name : null
          )
        )
      ),
    ]),
    _vm._v(" "),
    _c(
      "td",
      [
        _c("toggle-button", {
          attrs: {
            labels: { checked: "YES", unchecked: "NO" },
            color: { checked: _vm.$brandPrimary, unchecked: "#b7b7b7" },
          },
          on: {
            change: ({ value, srcEvent }) => _vm.toggleActiveStatus(value),
          },
          model: {
            value: _vm.opportunity.active,
            callback: function ($$v) {
              _vm.$set(_vm.opportunity, "active", $$v)
            },
            expression: "opportunity.active",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "edit-button",
          on: {
            click: function ($event) {
              return _vm.$emit("edit", _vm.opportunity.id)
            },
          },
        },
        [_c("i", { staticClass: "fa fa-fw fa-pencil-square-o" })]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }